import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';

// const root = ReactDOM.createRoot(document.getElementById('root'));
// root.render(

//   <React.StrictMode>
//     <BrowserRouter>
//       <App />
//     </BrowserRouter>
//   </React.StrictMode>
// )

const baseUrl = process.env.NODE_ENV === 'production' ? '/main' : '/';

ReactDOM.render(
  <React.StrictMode>
      <BrowserRouter 
        basename={baseUrl}  // {process.env.PUBLIC_URL} // was basename="/home"
        future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
      >
      <App />
      </BrowserRouter>
    
  </React.StrictMode>,
  document.getElementById('root')
);

